import { useCallback } from 'react';
import { Navigate } from 'react-router';
import { clearAlertsAction } from 'store/alert/alert.slice';
import { loginThunk } from 'store/authentication/authentication.thunks';

import { useAppDispatch, useAppSelector } from '../../../store';
import { LoginForm } from '../../forms/login-form/login-form';

export const LoginPage = () => {
  const dispatch = useAppDispatch();

  const alert = useAppSelector((state) => state.alert);
  const loggedIn = useAppSelector((state) => state.authentication.loggedIn);

  const handleSubmit = useCallback(
    ({ username, password }: { username: string; password: string }) => {
      if (username && password) {
        dispatch(loginThunk({ username, password }));
        dispatch(clearAlertsAction());
      }
    },
    [dispatch],
  );

  if (loggedIn) {
    return <Navigate to="/" />;
  }

  return <LoginForm onSubmit={handleSubmit} alert={alert} />;
};
